<template>
    <div class="container page-title mt-4">
        <div class="double">
            <h1 class="block-title">Корзина <span class="sum_cart">на {{ this.total_formatted }}Р</span></h1>
            <div class="dropdown">
                <button class="btn btn-outline-regular mb-0 dropdown-toggle" type="button" id="dropdown_menu_cabinet" data-bs-toggle="dropdown" aria-expanded="false">
                    Действие с корзиной
                </button>
                <ul class="dropdown-menu dropdown-menu-end cart-menu" aria-labelledby="dropdown_menu_cart">
                    <li><a href="#" class="dropdown-item">Очистить корзину</a></li>
                    <li><a href="#" class="dropdown-item">Добавить все в избранное</a></li>
                    <li><a href="#" class="dropdown-item">Создать корзину из XLS</a></li>
                    <li><a href="#" class="dropdown-item">Сохранить корзину в XLS</a></li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import CartItem from "./CartItem.vue";

export default {
    components: {CartItem},
    methods: {
    },
    computed: {
        items() {
            return this.$store.state.cart.items;
        },
        total() {
            return this.$store.state.cart.total;
        },
        total_formatted () {
            return this.$store.state.cart.total_formatted ;
        },
    },
};
</script>
